export default __webpack_public_path__ + "static/media/history.201478d1.svg";